import { render, staticRenderFns } from "./ItemListDefaultLayout.vue?vue&type=template&id=68145fba&scoped=true&"
import script from "./ItemListDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./ItemListDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68145fba",
  null
  
)

export default component.exports